import { CheckCircleIcon } from "@heroicons/react/20/solid";

import { useAuth } from "~/contexts/AuthContext";
import { FoldSection } from "~/modules/dashboard/components/FoldSection.tsx";
import { UpcomingEventRows } from "~/modules/dashboard/components/UpcomingEventRows.tsx";
import { useDashboardUser } from "~/modules/dashboard/hooks/useDashboardUser.tsx";
import { useUpcomingEvents } from "~/modules/dashboard/hooks/useUpcomingEvents.ts";

/**
 * The events show on the own dashboard only, because the list reads own absences and own staffings.
 * The section shows also when it is empty, so the user sees that nothing is due. The to-dos are another
 * section: they show only when one is due. While the events load, the body stays empty and the pill shows a
 * spinner: the empty text would claim that nothing is due before the reads have answered. The list also waits
 * for all reads, because each read adds its own events, and the list would grow once for each answer.
 */
export function UpcomingSection() {
	const user = useDashboardUser();
	const { user: authUser } = useAuth();
	const isOwnDashboard = !!user && authUser?.id === user.id;
	const { events, isLoading } = useUpcomingEvents(isOwnDashboard);

	if (!isOwnDashboard) return null;

	return (
		<FoldSection title="Anstehende Termine"
					 storageKey="dashboard-upcoming-open"
					 count={events.length}
					 isLoading={isLoading}>
			{!isLoading && events.length === 0 && (
				<p className="flex min-h-11 items-center gap-2 rounded-lg border border-gray-200 bg-gray-50 px-3 py-2 text-sm text-gray-700">
					<CheckCircleIcon className="size-4 shrink-0 text-gray-500" />
					Es steht gerade nichts an
				</p>
			)}
			{!isLoading && events.length > 0 && <UpcomingEventRows events={events} />}
		</FoldSection>
	);
}
